var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTorightArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.499853 10.3345C0.371853 10.3345 0.243833 10.2858 0.1465 10.1878C-0.0488333 9.99251 -0.0488333 9.67582 0.1465 9.48048L4.45981 5.16717L0.1465 0.853857C-0.0488333 0.658523 -0.0488333 0.341833 0.1465 0.1465C0.341833 -0.0488333 0.658523 -0.0488333 0.853857 0.1465L5.52052 4.81317C5.71586 5.0085 5.71586 5.32519 5.52052 5.52052L0.853857 10.1872C0.755857 10.2859 0.627853 10.3345 0.499853 10.3345Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorightArrowIcon);
export default __webpack_public_path__ + "static/media/toright-arrow-icon.e9235f2a6e8a58f766b5540490a565c2.svg";
export { ForwardRef as ReactComponent };